export const updateShippingMethods = (form) => {
	 //Re show everything in case something was hidden earlier
	 $(".standard").removeClass('hidden');
	 $(".expedited").removeClass('hidden');
	 $(".next-day").removeClass('hidden');
	 $('.standard-territory').addClass('hidden');
	 $("#payment-info-create").show();
	 $('.shipMethodError').addClass('hidden');
	
	
	 if (form.shipping_state.value == 'GU'  || form.shipping_state.value == 'VI' || form.shipping_state.value == 'PR' || form.shipping_state.value == 'HI' || form.shipping_state.value == 'AK' || form.shipping_state.value == 'AS' || form.shipping_state.value == 'MP'){
	 	$(".expedited").addClass('hidden');
	 	$(".next-day").addClass('hidden');
	 	$('.next-day-info').slideUp();
	 	$(".standard").addClass('hidden');
	 	$(".standard-territory").removeClass('hidden');
	 	$('#standard-delivery-territory').prop("checked", true );
	 }
	 //if APO/FPO ..Only allow Standard Delivery to be selected
	 if (form.shipping_state.value == 'AA' || form.shipping_state.value == 'AE' || form.shipping_state.value == 'AP'){
	 	$(".expedited").addClass('hidden');
	 	$(".next-day").addClass('hidden');
	 	$('.next-day-info').slideUp();
	 	$(".standard").removeClass('hidden');
	 	$(".standard-territory").addClass('hidden');
	 	$('#standard-delivery').prop("checked", true );
	 }
	
	 //if PO Box...Only allow Regular to be selected
	 if ((form.shipping_address1.value.toLowerCase()).match('.*p[.\\s]*[o0][.\\s]*box.*')) {
		$(".next-day").addClass('hidden');
		$(".expedited").addClass('hidden');
	 	$('.next-day-info').slideUp();
	 	if (form.shipping_state.value == 'GU' || form.shipping_state.value == 'VI' || form.shipping_state.value == 'PR' || form.shipping_state.value == 'HI' || form.shipping_state.value == 'AK'){
	 		$('#standard-delivery-territory').prop("checked", true );
	 	} else {
	 		$('#standard-delivery').prop("checked", true );
	 	}
	 }
	
	 //if none of the shipping methods are selected and if USterritory or Hawaii or Alaska is hidden, select the default method(i.e. Standard Delivery(3-5 bus.days))
	 if(($('#standard-delivery').is(':checked') == false) && ($('#expedited-delivery').is(':checked') == false) && ($('#next-day').is(':checked') == false) && ($('.standard-territory').is(':hidden') == true)) {
	 	$('#standard-delivery').prop("checked", true );
	 }
};
